// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container for the tabs */
.nav-tabs {
  border-bottom: 2px solid #e9ecef;
  margin-bottom: 20px;
}

/* Each tab item */
.nav-tabs .nav-item {
  margin-bottom: -2px;
}

/* Tab links styling */
.nav-tabs .nav-link {
  font-size: 16px;
  font-weight: 500;
  padding: 10px 20px;
  color: #6c757d;
  border: none;
  border-bottom: 2px solid transparent;
  transition: all 0.3s ease;
}

/* Active tab styling */
.nav-tabs .nav-link.active {
  color: #17a2b8;
  border-bottom: 2px solid #17a2b8;
}

/* Hover effect */
.nav-tabs .nav-link:hover {
  color: #17a2b8;
  background-color: #f8f9fa;
}

/* Focus effect */
.nav-tabs .nav-link:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

/* Optional: Add a subtle shadow to give depth */
.nav-tabs .nav-link {
  box-shadow: none;
}

.nav-tabs .nav-link.active {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}
`, "",{"version":3,"sources":["webpack://./src/components/Tabs/Tabs.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA,gDAAgD;AAChD;EACE,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C","sourcesContent":["/* Container for the tabs */\n.nav-tabs {\n  border-bottom: 2px solid #e9ecef;\n  margin-bottom: 20px;\n}\n\n/* Each tab item */\n.nav-tabs .nav-item {\n  margin-bottom: -2px;\n}\n\n/* Tab links styling */\n.nav-tabs .nav-link {\n  font-size: 16px;\n  font-weight: 500;\n  padding: 10px 20px;\n  color: #6c757d;\n  border: none;\n  border-bottom: 2px solid transparent;\n  transition: all 0.3s ease;\n}\n\n/* Active tab styling */\n.nav-tabs .nav-link.active {\n  color: #17a2b8;\n  border-bottom: 2px solid #17a2b8;\n}\n\n/* Hover effect */\n.nav-tabs .nav-link:hover {\n  color: #17a2b8;\n  background-color: #f8f9fa;\n}\n\n/* Focus effect */\n.nav-tabs .nav-link:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n/* Optional: Add a subtle shadow to give depth */\n.nav-tabs .nav-link {\n  box-shadow: none;\n}\n\n.nav-tabs .nav-link.active {\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
